import * as ActionTypes from './ActionType';
import { sleep } from '../components/Functions'; //to communicate with server
import { apiUrl } from '../shared/baseUrl'; //to communicate with server
//import { fetchAuthSession } from 'aws-amplify/auth';
import { Auth } from 'aws-amplify';

export const userSignout = () => ({
    type: ActionTypes.USER_SIGNOUT
});

export const getToken = (params) => {
    return fetch(apiUrl + 'tokendynamicpool', {
        method: "POST",
        body: JSON.stringify(params),
        headers:{
            "Content-Type": "application/json",
            "Accept": "*/*",
            'Access-Control-Allow-Origin': '*'
        }
        });
};

// User
export const getUser = (username, token, ms=50, n=3) => async (dispatch) => {
    dispatch(userLogging());
    await sleep(ms);
    return fetch(apiUrl  + 'login_user_wm?username=' + username,{
    method:"GET",
    headers:{
    "Content-Type": "application/json",
    "Authorization": token
    }
    })
    .then(response => {
        if(response.ok){
            return response;
        } else {
            var error = new Error('Error ' + response.status + ':' + response.statusText);
            error.response = response;
            throw error;
        }
    },
    error => { //error handler
        var errmess = new Error('Error en Usuario o clave.');
        throw  errmess;
    })
    .then(response => response.json())
    .then(response => dispatch(addUser(response)))
    .catch(error => {
        if (n>0) {
            return dispatch(getUser(username, token, 10, n-1));
        }else{
            dispatch(userFailed(error.message));
        }
    });
}

export const userLogging = () => ({
    type: ActionTypes.USER_LOGGING
});
export const userFailed = (errmess) => ({
    type: ActionTypes.USER_FAILED,
    payload: errmess
});
export const addUser = (userdata) => ({
    type: ActionTypes.ADD_USER,
    payload: userdata
});
export const userReset = () => ({
    type: ActionTypes.USER_RESET
});

//Download Files
export const fetchFile = async (params) => {
    return fetch(apiUrl + 'retrieve_data_s3', {
        method: "POST",
        body: JSON.stringify(params),
        headers:{
            "Content-Type": "application/json",
            "Authorization": `${(await Auth.currentSession()).getIdToken().getJwtToken()}`
            //"Authorization": `${(await fetchAuthSession()).tokens.idToken.toString()}`

        }
        });
};

// Asset Series
export const fetchSeries = (tickers, token, ms=50, n=3) => async (dispatch) => {
    dispatch(seriesLoading());
    await sleep(ms);
    return fetch(apiUrl + 'get_series', {
        method: "POST",
        body: JSON.stringify(tickers),
        headers:{
            "Content-Type": "application/json",
            "Authorization": token
        }
        })
        .then(response =>{
            if(response.ok){
                return response;
            }
            else{
                console.log(response.status);
                console.log(response.statusText);
                var error = new Error('Error ' + response.status + ':' + response.statusText);
                error.response = response;
                throw error;
            }
        },
        error => { //error handler
            var errmess = new Error(error.message);
            throw  errmess;
        })
        .then(response => response.json())
        .then(data => dispatch(addSeries(data)))
        .catch(error => {
            if (n>0) {
                return dispatch(fetchSeries(tickers, token, 10, n-1));
            }else{
                 dispatch(seriesFailed(error.message));
            }
        });
}

export const seriesReset = () => ({
    type: ActionTypes.SERIES_RESET
});

export const seriesLoading = () => ({
    type: ActionTypes.SERIES_LOADING
});

export const seriesFailed = (errmess) => ({
    type: ActionTypes.SERIES_FAILED,
    payload: errmess
});

export const addSeries = (data) => ({
    type: ActionTypes.ADD_SERIES,
    payload: data
});

// ChatDoc get_response
export const getResponse = async (data, n=3) => {
    return fetch(apiUrl + 'get_response', {
        method: "POST",
        body: JSON.stringify(data),
        headers:{
            "Content-Type": "application/json",
            "Authorization": `${(await Auth.currentSession()).getIdToken().getJwtToken()}`
            //"Authorization": `${(await fetchAuthSession()).tokens.idToken.toString()}`
        }
        })
        .then(response =>{
            if(response.ok){
                return response;
            }
            else{
                var error = new Error('Error ' + response.status + ':' + response.statusText);
                error.response = response;
                throw error;
            }
        },
        error => { //error handler
            var errmess = new Error(error.message);
            throw  errmess;
        })
        .then(response => response.text())
        .catch(error => {
            if (n>0) {
                console.log(n);
                return getResponse(data, n-1);
            }
        });
};

export const getLlmResponse = async (data,  n=3) => {
    return fetch(apiUrl + "get_response", {
        method: "POST",
        body: JSON.stringify(data),
        headers:{
            "Content-Type": "application/json",
            "Authorization": `${(await Auth.currentSession()).getIdToken().getJwtToken()}`
            //"Authorization": `${(await fetchAuthSession()).tokens.idToken.toString()}`
        }
        })
        .then(response =>{
            if(response.ok){
                return response;
            }
            else{
                var error = new Error('Error ' + response.status + ':' + response.statusText);
                error.response = response;
                throw error;
            }
        },
        error => { //error handler
            var errmess = new Error(error.message);
            throw  errmess;
        })
        .then(response => response.json())
        .catch(error => {
            if (n>0) {
                console.log(n);
                return getLlmResponse(data, n-1);
            }
        });
};

//Download Files
export const fetchJsonFile = async (params) => {
    try {
        const response = await fetch(apiUrl + 'retrieve_json_s3', {
            method: "POST",
            body: JSON.stringify(params),
            headers:{
                "Content-Type": "application/json",
                "Authorization": `${(await Auth.currentSession()).getIdToken().getJwtToken()}`
            }
            });
        if (!response.ok) {
            let error;
            try {
                // Attempt to parse the response body as JSON for additional error info
                const errorBody = await response.json();
                error = new Error(`Error: ${errorBody.msg || ''}`);
            } catch (parsingError) {
                error = new Error("Error: Archivo inválido.");
            }
            error.response = response;
            throw error;
        }
        return await response.json();
        
    } catch(error){
        throw error;    
    }
};


// Generic Request
export const getRequest = async (data, endpoint, n=1) => {
    try {
        const paramsStr = '?' + new URLSearchParams(data).toString();
        const response = await fetch(apiUrl + endpoint + paramsStr, {
            method: "GET",
            headers:{
                "Content-Type": "application/json",
                "Authorization": `${(await Auth.currentSession()).getIdToken().getJwtToken()}`
            }
        });
        if (!response.ok) {
            let error;
            try {
                // Attempt to parse the response body as JSON for additional error info
                const errorBody = await response.json();
                error = new Error(`Error: ${errorBody.msg || ''}`);
            } catch (parsingError) {
                error = new Error("Error.");
            }
            error.response = response;
            throw error;
        }
        return await response.json();
    } catch (error) {
        if (n>0) {
            console.log(n);
            return getRequest(data, endpoint, n-1);
        }else{
         console.error("Request failed:", error);
         throw error;
        }
    }
};

export const postRequest = async (data, endpoint, n=1) => {
    try {
        const response = await fetch(apiUrl + endpoint, {
            method: "POST",
            body: JSON.stringify(data),
            headers:{
                "Content-Type": "application/json",
                "Authorization": `${(await Auth.currentSession()).getIdToken().getJwtToken()}`
            }
        });
        if (!response.ok) {
            let error;
            try {
                // Attempt to parse the response body as JSON for additional error info
                const errorBody = await response.json();
                error = new Error(`Error: ${errorBody.msg || ''}`);
            } catch (parsingError) {
                error = new Error("Error: Archivo inválido.");
            }
            error.response = response;
            throw error;
        }
        return await response.json();
    } catch (error) {
        if (n>0) {
            console.log(n);
            return postRequest(data, endpoint, n-1);
        }else{
         console.error("Request failed:", error);
         throw error;
        }
    }
};

export const fetchData = (data, endpoint, actions, n = 2, key = null) => async (dispatch) => {
  dispatch({ type: actions.loading });
  await sleep(50);

  return fetch(apiUrl + endpoint, {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      "Authorization": `${(await Auth.currentSession()).getIdToken().getJwtToken()}`
    }
  })
    .then(async response => {
      if (response.ok) {
        return response.json();
      } else {
        const errorBody = await response.json();
        const error = new Error("Error: No se pueden cargar datos.");
        error.status = response.status;
        error.body = errorBody;
        throw error;
      }
    })
    .then(data => {
      let payload = data;
      if (key !== null) {
        if (Array.isArray(key)) {
          // Return object with each key and its corresponding data
          payload = key.reduce((acc, k) => {
            acc[k] = data[k] !== undefined ? data[k] : null;
            return acc;
          }, {});
        } else {
          // Single key
          payload = data[key];
        }
      }

      dispatch({ type: actions.add, payload });
      return { success: true, data }; // ✅ Return value when successful
    })
    .catch(error => {
      if (n > 0) {
        return dispatch(fetchData(data, endpoint, actions, n - 1, key));
      } else {
        dispatch({ type: actions.failed, payload: error.body?.msg || error.message });
        return { success: false }; // ✅ Return value when failed
      }
    });
};
// Presigned URL
export const getPresignedUrl = async (data) => {
    try {
        const response = await fetch(apiUrl + 'link_data_s3', {
            method: "POST",
            body: JSON.stringify(data),
            headers:{
                "Content-Type": "application/json",
                "Authorization": `${(await Auth.currentSession()).getIdToken().getJwtToken()}`
            }
        });
        
        if (!response.ok) {
            let error;
            try {
                // Attempt to parse the response body as JSON for additional error info
                const errorBody = await response.json();
                console.log(errorBody)
                error = new Error(`Error: ${errorBody.msg || ''}`);
            } catch (parsingError) {
                console.log(parsingError)
                error = new Error("Error: Archivo inválido.");
            }
            error.response = response;
            throw error;
        }
        return await response.text();
    } catch (error) {
        console.error("Request failed:", error);
        throw error;
    }
};

export const runJob = async (data) => {
    return fetch(apiUrl + 'run_glue_job', {
        method: "POST",
        body: JSON.stringify(data),
        headers:{
            "Content-Type": "application/json",
            "Authorization": `${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        }
        });
};

export const validateFile = async (data) => {
    try {
        const response = await fetch(apiUrl + 'validate_suitability_inputs', {
            method: "POST",
            body: JSON.stringify(data),
            headers:{
                "Content-Type": "application/json",
               "Authorization": `${(await Auth.currentSession()).getIdToken().getJwtToken()}`
            }
            });
        if (!response.ok) {
            let error;
            try {
                // Attempt to parse the response body as JSON for additional error info
                const errorBody = await response.json();
                error = new Error(`Error: ${errorBody.msg || ''}`);
            } catch (parsingError) {
                console.log(parsingError)
                error = new Error("Error: Archivo inválido.");
            }
            error.response = response;
            throw error;
        }
        return await response.json();
    } catch (error) {
        throw error;
    }
};

